'use strict';

const _ = require('lodash');

const Enum = require('./enum');

module.exports.Brands = Object.create(Enum, {
  AUGUST: { value: 'august', enumerable: true },
  CHIRP: { value: 'chirp', enumerable: true },
  YALE: { value: 'yale', enumerable: true },
  AUGUST_YALE: { value: 'august_yale', enumerable: true },
  YALECHINA: { value: 'yalechina', enumerable: true },
  PANPAN: { value: 'panpan', enumerable: true },
  GATEMAN: { value: 'gateman', enumerable: true },

  getAppName: {
    value: function(brand) {
      return _.get(brands, `${brand}.appName`, brands[this.AUGUST].appName);
    },
  },

  getBrand: {
    value: function(brand) {
      return _.get(brands, brand, brands[this.AUGUST]);
    },
  },
});

/**
 * General brand data that will not be translated
 *
 * NOTE If you have brand data that will be translated, put it into august-babelfish
 *
 * brandName - official full brand name
 * deviceBrandName - common name when referring to a device f.e. "August Smart Lock", "Yale Assure Lock"
 * appName - app name as used on a phone's home screen
 * appStoreName - app name as used in the app store
 * appHostName - used for 2FA validation URLs
 * appLink - app product page or app store link
 * fromEmail - sender email address used for notification emails
 * website - website without protocol, to be used in text
 * websiteUrl - website including protocol, to be used in links
 */
const brands = {
  [exports.Brands.AUGUST]: {
    brandName: 'August Home',
    deviceBrandName: 'August',
    appName: 'August',
    appStoreName: 'August Home',
    appHostName: 'account.august.com',
    appLink: 'https://www.august.com/app',
    fromEmail: 'August Home <noreply@august.com>',
    website: 'www.august.com',
    websiteUrl: 'https://www.august.com',
  },

  [exports.Brands.YALE]: {
    brandName: 'Yale',
    deviceBrandName: 'Yale',
    appName: 'Yale',
    appStoreName: 'Yale Access',
    appHostName: 'account.august.com',
    appLink: 'https://www.yalehome.com/global/en/trusted-innovation/yale-apps/download-yale-access',
    fromEmail: 'Yale Access <noreply@yaleaccess.com>',
    website: 'www.yaleaccess.com',
    websiteUrl: 'https://www.yaleaccess.com',
  },

  // This is a pseudo brand, used only in august-oauth to show a combined Yale/August logo.
  // Fields that don't apply have been left blank.
  [exports.Brands.AUGUST_YALE]: {
    brandName: 'August or Yale',
    deviceBrandName: 'August or Yale',
    appName: 'August or Yale Access',
    appStoreName: 'August or Yale',
    appHostName: '',
    appLink: '',
    fromEmail: '',
    website: '',
    websiteUrl: '',
  },

  [exports.Brands.YALECHINA]: {
    brandName: 'Yale',
    deviceBrandName: 'Yale',
    appName: 'Yale',
    appStoreName: 'Yale Access',
    appHostName: '',
    appLink: 'http://cdn-ui-resources.aaecosys.com/app/brands/urls/yaleChina/CN/zh/download.html',
    fromEmail: 'Yale Access <eco.support@assaabloy.com>',
    website: '', // NOTE TBD, website is still under construction
    websiteUrl: '', // NOTE TBD, website is still under construction
  },

  [exports.Brands.PANPAN]: {
    brandName: 'PANPAN',
    deviceBrandName: 'PANPAN',
    appName: 'PANPAN',
    appStoreName: 'PANPAN',
    appHostName: '',
    appLink: 'http://cdn-ui-resources.aaecosys.com/app/brands/urls/panpan/CN/zh/download.html',
    fromEmail: 'PANPAN <eco.support@assaabloy.com>',
    website: '', // NOTE TBD, website is still under construction
    websiteUrl: '', // NOTE TBD, website is still under construction
  },

  [exports.Brands.GATEMAN]: {
    brandName: 'Gateman',
    deviceBrandName: 'Gateman',
    appName: 'Gateman',
    appStoreName: 'Gateman Access',
    appHostName: 'account.august.com',
    appLink: 'https://www.egateman.co.kr/ko',
    fromEmail: 'Gateman Access <noreply@gatemanaccess.com>',
    website: 'www.egateman.co.kr/ko',
    websiteUrl: 'https://www.egateman.co.kr/ko',
  },

  // external / non Assa Abloy

  [exports.Brands.CHIRP]: {
    brandName: 'Chirp Systems',
    deviceBrandName: 'August',
    appName: 'Chirp Access',
    appStoreName: 'Chirp Access',
    appHostName: 'account.august.com',
    appLink: 'https://apps.apple.com/us/app/chirp-access/id1450159493',
    fromEmail: 'Chirp <support@chirpsystems.com>',
    website: 'www.chirpsystems.com',
    websiteUrl: 'https://www.chirpsystems.com',
  },
};
